import Vue from "vue";
import Vuex from "vuex";
import Cookies from "js-cookie";
Vue.use(Vuex);

import * as getters from "./getters";
import * as actions from "./actions";
import * as mutations from "./mutations";

let spaceUserInfo = {
  company_name: "",
  name: "",
  company_industry: "",
  position: "",
  phone_number: "",
  nickName: "",
  nickname: "",
  category: "",
  certificationAttribute: "",
  avatar: ""
};

const state = {
  token: Cookies.get("token") || "", // token
  local: "zh",
  userInfo: Cookies.get("userInfo")
    ? JSON.parse(Cookies.get("userInfo"))
    : spaceUserInfo, //持久化用户信息
  isLogin: Cookies.get("token") ? true : false, // 原登录判断
  hasPhone:
    Cookies.get("token") && JSON.parse(Cookies.get("userInfo")) ? true : false, // 手机号判断
  CategoryTree: [],
  FreezingModeList: [],
  articleCategory: [],
  category: "", //品类
  freez: "", //冷冻系列
  productDetail: "", // 商品详情
  historyPrice: "", // 出价列表
  navFirstName: Cookies.get("navFirstName") ? Cookies.get("navFirstName") : "", //导航的第一个menu的名字
  user: Cookies.get("user") ? JSON.parse(Cookies.get("user")) : spaceUserInfo // 用户
};
const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js